// extracted by mini-css-extract-plugin
module.exports = {"NavLink":"ReferralsFilter_NavLink__W-ocb","isActive":"ReferralsFilter_isActive__sP4bL"};